import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { DeviceUUID } from 'device-uuid';

@Injectable({
  providedIn: 'root',
})
export class DeviceUuidGuard {

  private readonly router = inject(Router);

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const queryParams = activatedRouteSnapshot.queryParams;
    const deviceUUID = new DeviceUUID();
    const staticData = queryParams?.staticData && JSON.parse(decodeURIComponent(queryParams?.staticData));
    const expiredContractSigned = coerceBooleanProperty(queryParams?.expiredContractSigned);

    if (staticData?.deviceUUID && deviceUUID.get() !== staticData.deviceUUID) {
      const staticPage = expiredContractSigned ? 'expired' : staticData.staticPage ?? 'fail';

      this.router.navigate(['/pay', 'static-finish', staticData.paymentMethod, staticPage], {
        queryParams,
      });

      return false;
    }

    return true;
  }
}
